import { Store } from '@ngrx/store';
import { Component, signal, Output, EventEmitter, computed, model, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselVisitDetailVesselComponent } from './vessel-visit-detail-vessel/vessel-visit-detail-vessel.component';
import { selectSelectedVesselActivitiesIndices, selectSelectedVesselVisit, VesselStopTypeForStepper, selectEditingVesselActivities, selectVesselVisitIsDirty, VesselTransitStatusId, IVesselActivity, VesselMovementActionTypes, VesselMovementButtonActions } from '@pmis3/vessel-activity-core';
import { VesselTransitStatus } from '@pmis3/vessel-activity-core';
import { IconsModule } from '@progress/kendo-angular-icons';
import { KENDO_BUTTONS } from "@progress/kendo-angular-buttons";
import { VesselVisitDetailNOAComponent } from './vessel-visit-detail-noa/vessel-visit-detail-noa.component';
import { KENDO_TABSTRIP, SelectEvent } from "@progress/kendo-angular-layout";
import { VesselVisitDetailMovementComponent } from './vessel-visit-detail-movement/vessel-visit-detail-movement.component';
import { VesselVisitStepperComponent } from '../vessel-visit-stepper/vessel-visit-stepper.component';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { IVesselVisit } from '@pmis3/vessel-activity-core';
import { ISeaport } from '@pmis3/ui-features';

@Component({
	selector: 'pmis3-vessel-visit-detail',
	standalone: true,
	imports: [
		CommonModule,
		VesselVisitDetailVesselComponent,
		IconsModule,
		KENDO_BUTTONS,
		VesselVisitDetailNOAComponent,
		KENDO_TABSTRIP,
		KENDO_DROPDOWNS,
		VesselVisitDetailMovementComponent,
		VesselVisitStepperComponent,
		KENDO_LABEL,
		KENDO_INPUTS
	],
	templateUrl: 'vessel-visit-detail.component.html',
	styleUrl: 'vessel-visit-detail.component.css'
})
export class VesselVisitDetailComponent {
	vesselVisit = this.store.selectSignal(selectSelectedVesselVisit);
	editingVesselActivities = this.store.selectSignal(selectEditingVesselActivities);
	vesselActivities = this.store.selectSignal(selectEditingVesselActivities);
	groupedIndicesForEditingVesselActivities = this.store.selectSignal(selectSelectedVesselActivitiesIndices);
	vesselVisitIsDirty = this.store.selectSignal(selectVesselVisitIsDirty);

	vesselVisitState = signal(VesselTransitStatus.Pending);
	collapsedVesselAndNOA = model(false);
	activeTabIndex = signal(0);
	allVisitFieldsValid = signal(false);
	allActivityFieldsValid = signal(true);

	seaports = input<ISeaport[]>([]);

	visitHasVesselActivities = computed(() => {
		const vesselActivities = this.editingVesselActivities();
		return !!vesselActivities && vesselActivities.length > 0
	})
	selectedVessel = computed(() => this.vesselVisit()?.vessel);
	NOADisabled = computed(() => !this.allActivityFieldsValid() || !this.allVisitFieldsValid() || !this.visitHasVesselActivities() || !this.vesselVisitIsDirty())

	@Output() submitNOA: EventEmitter<IVesselVisit> = new EventEmitter<IVesselVisit>();
	@Output() saveNOA: EventEmitter<IVesselVisit> = new EventEmitter<IVesselVisit>();
	@Output() back = new EventEmitter<void>();

	constructor(private store: Store<any>) { }

	goBack() {
		this.back.emit();
	}

	addMovements() {
		this.collapsedVesselAndNOA.set(true);
	}

	onSaveNOA() {
		this.emitNOA(VesselMovementButtonActions.Save);
	}

	onSubmitNOA() {
		this.emitNOA(VesselMovementButtonActions.Submit);
	}

    // TODO: Implement a proper life cycle for object
	private emitNOA(action: VesselMovementButtonActions.Save | VesselMovementButtonActions.Submit) {
		const vesselActivities = this.editingVesselActivities()?.map(va => ({
			...va,
			statusId: action === VesselMovementButtonActions.Save
				? VesselTransitStatusId.Draft
				: VesselTransitStatusId.Pending
		}));
		
		const updatedVV: IVesselVisit = {
			...this.vesselVisit(),
			vesselActivities
		} as IVesselVisit;

		if (action === VesselMovementButtonActions.Save) {
			this.saveNOA.emit(updatedVV);
		}
		else {
			this.submitNOA.emit(updatedVV);
		}
	};


	onEdit() {
		this.collapsedVesselAndNOA.set(false);
	}

	onTabSelect(event: SelectEvent): void {
		this.activeTabIndex.set(event.index);
	}
}
